import React from 'react';
import Header from './component/Header';
import Tindercards from './views/tindercards/TinderCards';
import SwipeButtons from './views/swipebuttons/SwipeButtons';
import Chats from './views/chat/Chats';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import ChatScreen from './views/chat/ChatScreen';


function Tinderclone() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/chats/:person">
            <Header backButton="/chats" />
            <ChatScreen />
          </Route>
          <Route path="/chats">
            <Header backButton="/" chat="/" />
            <Chats />
          </Route>
          <Route path="/">
            <Header />
            <Tindercards />
            <SwipeButtons />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default Tinderclone;

